import styled from 'styled-components'
import { rem } from 'polished'

/** Matches `TrackCap` width in `LuxKit/Slider/DualSlider.tsx`. */
const SLIDER_TRACK_INSET_PX = 24
/**
 * Pulls the histogram down to meet the DualSlider track.
 * Coupled to DualSliderInput layout — revisit if TrackCap/track height changes.
 */
const HISTOGRAM_VERTICAL_OFFSET_PX = -9

const HISTOGRAM_HEIGHT_PX = 48
const BAR_GAP_PX = 2
const MIN_BAR_HEIGHT_PX = 4

const Histogram = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${rem(BAR_GAP_PX)};
  height: ${rem(HISTOGRAM_HEIGHT_PX)};
  width: 100%;
  margin-bottom: ${rem(HISTOGRAM_VERTICAL_OFFSET_PX)};
  padding-inline: ${rem(SLIDER_TRACK_INSET_PX)};
  box-sizing: border-box;
`

const Bar = styled.div<{ $height: number }>`
  flex: 1;
  min-width: 0;
  height: ${props => rem(props.$height)};
  background-color: ${props => props.theme.palette.neutral.default.five};
  border-start-start-radius: ${rem(2)};
  border-start-end-radius: ${rem(2)};
`

interface Props {
  buckets: Array<number>
}

function FlightPriceHistogram(props: Props) {
  const { buckets } = props
  const max = Math.max(...buckets, 1)

  if (!buckets.length) {
    return null
  }

  return (
    <Histogram>
      {buckets.map((count, index) => {
        const height = count === 0
          ? 0
          : Math.max(MIN_BAR_HEIGHT_PX, Math.round((count / max) * HISTOGRAM_HEIGHT_PX))

        return <Bar key={`histogram-bar-${count}-${index}`} $height={height} />
      })}
    </Histogram>
  )
}

export default FlightPriceHistogram
